import React from 'react';
import PropTypes from 'prop-types';
import { IcepackForm } from '../icepack-filled-form';
import { SimpleTableComponent } from '../../../../components/simple-table';
import { ICEPACK_FILLED_TABLE_COLUMNS_NAMES } from '../../constants';

export const IcepackFilledModalContent = ({ isLoading, icepackFilledInfo, isIcepackFilledFormOpen }) => {
	if (isIcepackFilledFormOpen) {
		return <IcepackForm isLoading={isLoading} />;
	}

	return (
		<SimpleTableComponent
			rows={icepackFilledInfo}
			isTableDataLoading={isLoading}
			columns={ICEPACK_FILLED_TABLE_COLUMNS_NAMES}
			withOutMinHeight
		/>
	);
};

IcepackFilledModalContent.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	icepackFilledInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					name: PropTypes.string,
					role: PropTypes.string,
				}),
			]).isRequired,
		}),
	),
	isIcepackFilledFormOpen: PropTypes.bool.isRequired,
};
